import { track } from '../../helpers/tracking';

export interface trackedCartItemInterface {
    name: string;
    configSku: string;
    simpleSku: string;
    campaignIdentifier: string;
    brand: string;
    price: number;
    size: string;
    nameCategoryTag: string;
    nameColor: string;
    brandCode: string;
    reco: number;
    gender?: string;
}
export const trackOrderFilter = (cartItem: trackedCartItemInterface) => {
    const gender = Array.isArray(cartItem.gender) ? cartItem.gender.join(',') : cartItem.gender;

    const trackData = {
        ecommerce: {
            remove: {
                products: [
                    {
                        name: cartItem.name,
                        id: cartItem.configSku,
                        price: cartItem.price,
                        brand: cartItem.brand,
                        category: cartItem.nameCategoryTag,
                        variant: cartItem.nameColor,
                        quantity: 1,
                        dimension1: cartItem.size,
                        dimension2: gender || 'N/A',
                        dimension3: cartItem.brandCode,
                        dimension4: cartItem.campaignIdentifier,
                        dimension5: cartItem.reco,
                        dimension54: 'N/A',
                    },
                ],
            },
        },
    };

    track('removeFromCart', trackData);
};
